import axios from 'axios'

// create an axios instance
const service = axios.create({
  // baseURL: 'http://chenyp.top:8008', // url = base url + request url

 
  // baseURL: 'http://192.168.10.62:8010',
  baseURL: 'https://api.xaryxx.com', // url = base url + request url
  // baseURL: 'http://192.168.10.62:8010',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// 192.168.10.62:8010/homepage/queryAll

// request interceptor
service.interceptors.request.use(
  config => config
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    return response.data;
  }
)

export default service


// WEBPACK FOOTER //
// ./src/api/request.js